import videojs from 'video.js';
import SkipButtons from './SkipButtons';
import './Skip.scss';

const Plugin = videojs.getPlugin('plugin');

class Skip extends Plugin {
    constructor(player, options = {}) {
        super(player, options);

        this.createSkipButtons(player);
    }

    createSkipButtons(player) {
        const {parent, index} = player.findChild('DurationDisplay')[0];
        const skipButtons = new SkipButtons(player);
        parent.addChild(skipButtons, {}, index + 1);
        this.on('dispose', () => {
            parent.removeChild(skipButtons);
        });
    }
}

videojs.registerPlugin('skip', Skip);
